const CAROUSEL_ITEMS = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20style%20visual%20with%20warm%20amber%20lighting%20featuring%20an%20intense%20crime%20drama%20scene%2C%20two%20men%20in%20silhouette%20against%20city%20night%20skyline%2C%20film%20noir%20aesthetic%2C%20modern%20Chinese%20drama%20vibe%2C%20high%20contrast%2C%20atmospheric&width=800&height=500&seq=carousel-01&orientation=landscape',
    title: '狂飙',
    tag: '年度现象级',
    desc: '扫黑题材天花板，张译张颂文贡献教科书级演技，豆瓣9.1分口碑爆棚。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20scene%20with%20a%20massive%20spaceship%20floating%20above%20earth%2C%20cosmic%20scale%2C%20deep%20space%20background%20with%20stars%2C%20cinematic%20lighting%2C%20epic%20composition%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20movie%20poster%20quality&width=800&height=500&seq=carousel-02&orientation=landscape',
    title: '三体',
    tag: '必看科幻',
    desc: '刘慈欣科幻巨著改编，视觉特效震撼人心，国产科幻新标杆之作。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20period%20drama%20scene%20set%20in%201980s%20Shanghai%2C%20elegant%20man%20in%20vintage%20suit%20walking%20on%20a%20rainy%20neon-lit%20street%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20tones%2C%20cinematic%20composition%2C%20film%20grain%20texture&width=800&height=500&seq=carousel-03&orientation=landscape',
    title: '繁花',
    tag: '王家卫首部剧',
    desc: '胡歌马伊琍唐嫣联袂，上海滩三十载风云变幻，一帧一画皆是电影。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=An%20epic%20space%20adventure%20scene%20with%20astronauts%20floating%20near%20a%20giant%20space%20station%2C%20earth%20in%20background%2C%20dramatic%20lighting%2C%20cinematic%20photography%2C%20heroic%20composition%2C%20warm%20sunlight%20hitting%20the%20spacecraft%2C%20movie%20poster%20aesthetic&width=800&height=500&seq=carousel-04&orientation=landscape',
    title: '流浪地球2',
    tag: '科幻里程碑',
    desc: '吴京刘德华领衔，国产科幻史诗续作，视觉与情感双重震撼体验。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20anime%20style%20art%20scene%20with%20Japanese%20warriors%20in%20traditional%20setting%20under%20cherry%20blossoms%2C%20sword%20fighting%20pose%2C%20dramatic%20wind%20effect%2C%20vibrant%20colors%2C%20warm%20sunset%20lighting%2C%20cinematic%20anime%20composition%2C%20high%20quality&width=800&height=500&seq=carousel-05&orientation=landscape',
    title: '鬼灭之刃',
    tag: '人气动漫',
    desc: '锻刀村篇火爆上线，ufotable顶级制作水准，燃到停不下来。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20military%20action%20scene%20with%20fighter%20jets%20flying%20through%20clouds%20at%20sunset%2C%20warm%20golden%20sky%2C%20heroic%20visual%2C%20cinematic%20aerial%20photography%2C%20powerful%20composition%2C%20film%20poster%20quality%2C%20Chinese%20movie%20aesthetic&width=800&height=500&seq=carousel-06&orientation=landscape',
    title: '长空之王',
    tag: '热血动作',
    desc: '王一博胡军主演，试飞员的蓝天梦想，中国航空力量震撼呈现。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">焦点专题</h2>
          <p className="text-sm text-foreground-500 mt-2">精选热门影视专题，一睹为快</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CAROUSEL_ITEMS.map((item) => (
            <div
              key={item.title}
              className="rounded-2xl overflow-hidden bg-background-100 group cursor-pointer hover:bg-background-200/70 transition-colors"
            >
              <div className="relative h-[200px] md:h-[240px] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] font-semibold bg-primary-500 text-background-50 px-2 py-1 rounded-full">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent" />
              </div>
              <div className="p-4">
                <h3 className="text-base font-bold text-foreground-950 mb-1 font-heading">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}